"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Blok = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _MuiGrid = _interopRequireDefault(require("../../../MuiGrid/MuiGrid"));

var _MuiTabs = _interopRequireDefault(require("../../../MuiTabs/MuiTabs"));

var _MuiHeroHeader = _interopRequireDefault(require("../../../MuiHeroHeader/MuiHeroHeader"));

var _MuiAppBar = _interopRequireDefault(require("../../../MuiAppBar/MuiAppBar"));

var _MuiBottomNavigation = _interopRequireDefault(require("../../../MuiBottomNavigation/MuiBottomNavigation"));

var _MuiGeoLocationTabs = _interopRequireDefault(require("../../../MuiGeoLocationTabs/MuiGeoLocationTabs"));

var _customComponents = require("../../../../utils/customComponents");

var Blok = function Blok(_ref) {
  var content = _ref.content,
      only = _ref.only;
  var components = {
    MuiTabs: _MuiTabs.default,
    MuiGrid: _MuiGrid.default,
    MuiHeroHeader: _MuiHeroHeader.default,
    MuiAppBar: _MuiAppBar.default,
    MuiBottomNavigation: _MuiBottomNavigation.default,
    MuiGeoLocationTabs: _MuiGeoLocationTabs.default
  };
  return /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    only: only
  }, content.map(function (component, key) {
    return (0, _customComponents.renderComponents)(components, component, key);
  }));
};

exports.Blok = Blok;
var _default = Blok;
exports.default = _default;
Blok.propTypes = {
  /**
   * mui prop array of: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
   * Hide the given breakpoint(s).
   * */
  only: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * MuiGrid,
  *  MuiHeroHeader,
  *  MuiAppBar,
  */
  content: _propTypes.default.arrayOf(_propTypes.default.shape({
    component: _propTypes.default.string.isRequired
  })).isRequired
};
Blok.defaultProps = {
  only: []
};